export default __webpack_public_path__ + "static/media/pin_icon.1a08380c.svg";